import { useGetHepExercisesQuery } from "./hepexercisesApiSlice"
import { memo } from 'react'

const HepExercisePrint = ({ hepId }) => {

    const { hep } = useGetHepExercisesQuery("hepexercisesList", {
        selectFromResult: ({ data }) => ({
            hep: data?.entities[hepId]
        }),
    })


    if (hep) {
        return (
            <>
            <div className="row mb-1 mt-5">
                <div className="col-md-12" style={{'fontWeight': '600', 'fontSize':'large'}}>{hep.exercise_id.exercise_name}</div>
            </div>
            <div className="row mb-1">
                <div className="col-md-12">{hep.exercise_id.exercise_details}</div>
            </div>
            <div className="row mb-1">
                <div className="col-md-12" style={{'fontWeight': '600'}}>{hep.description}</div>
            </div>
            {(hep.exercise_id.video) &&
                <div className="row mb-1">
                <div className="col-md-12" style={{'fontWeight': '600'}}><a href={hep.exercise_id.video}>Show Video</a></div>
            </div>                
            }
            </>
        )

    } else return null
}

const memoizedHep = memo(HepExercisePrint)

export default memoizedHep